"use client";
import { type ReactNode, createContext } from "react";

type ServerContextType = {
  isMobile: boolean;
  session: any;
};

export const ServerContext = createContext<ServerContextType>({
  isMobile: false,
  session: null,
});

export function ServerContextProvider({
  children,
  value,
}: {
  children: ReactNode;
  value: any;
}) {
  return (
    <ServerContext.Provider value={value}>{children}</ServerContext.Provider>
  );
}
